import React from "react"
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from "react-router-dom"
import App from './App.js'
import { startAppVersionMonitor } from './services/appVersion'

// ReactDOM.render(<App />, document.getElementById('root'))

// const container = document.getElementById('root')

const root = ReactDOM.createRoot(document.getElementById('root'))

startAppVersionMonitor()

// root.render(<App key='app'/>)
// root.render(<App />)

root.render(
        <BrowserRouter>
                <App id='app' />
        </BrowserRouter>
)
